import React, { useCallback, useState, useEffect } from 'react'
import { useFormikContext, useField } from 'formik'
import RegionPicker from '../region-picker'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'
import {fetchStatesByCountry} from '../../../../utils/global-fetchs'
import NormalInput from '../normal-input'

export const StateSelector = props => {
    useStyles(classes)
    const { countries, states, formikContext } = props
    const [show, setShow] = useState(false)

    const {
        setFieldValue,
        touched,
        values
    } = formikContext

    const [field, meta] = useField(props)

    const selectHandle = useCallback(({ country, state, city, zipCodes }) => {
        setFieldValue('country', country)
        if(state){
            setFieldValue('state', state)
        }
        if(city){
            setFieldValue('city', city)
        }
        if(zipCodes){
            setFieldValue('zipCodes', zipCodes)
        }
    }, [])

    return <>
        <div className={`${classes.CountryInput} ${!field?.value? classes.Empty: ''}`} onClick={e => setShow(true)}>
            <div className={classes.Main}>
                <div className={classes.Label}>
                    {props.label}
                </div>
                <div className={classes.Info}>
                    <div className={classes.Content}>
                        <select {...field}>
                            {
                                states?.map?.(s => <option value={s?.value} key={s?.value}>{s?.label}</option>)
                            }
                        </select>
                    </div>
                </div>
            </div>
            <Iconfont className={classes.Sword}>&#xe690;</Iconfont>
        </div>
        {meta.touched && meta.error && <div className={classes.Error}>{meta.error}</div>}
        <RegionPicker currentStep={2} show={show} countries={countries} country={values.country} state={field.value} onSelect={selectHandle} onClose={() => setShow(false)} />
    </>
}



export default props => {
    const [states, setStates] = useState(null)

    const formikContext = useFormikContext()

    const { values } = formikContext

    useEffect(async () => {
        setStates(await fetchStatesByCountry(values?.country))
    }, [values?.country])

    return states?.length > 0 ? <><StateSelector {...props} states={states} formikContext={formikContext}/><div style={{borderTop: '1px solid #e6e6e6'}}/></> : <NormalInput {...props}/>
}